import { FilterGroup } from '@/helpers/powerbi-helper'
import { PowerBIReport } from '@/components/powerbi-report/powerbi-report'
import { ContainerViewport } from '@platformui/core/base/sensors/ContainerViewport'
import { GenericBlockData } from '@platformui/core/infrastructure/features/renderer/block-renderer-types'
import { typeCheckedProps } from '@platformui/core/infrastructure/features/renderer/utils'
import { FC } from 'react'

export type GraphBlockProps = {
    heading?: string
    preamble?: string
    sectionID?: string
    hideAnchorLink: boolean
    anchorSectionId: string
    anchorLinkLevel: number
} & GraphBlockPowerBIComponentProps

type GraphBlockPowerBIComponentProps = {
    reportID?: string
    token?: string
    url?: string
    disableExport?: boolean
    apiLoaded?: string
    filters?: FilterGroup[]
    translations: {
        addfilters: string
        addfiltersbutton: string
        clearall: string
        closeexport: string
        closefilterselection: string
        export: string
        exportheadline: string
        filterheadline: string
        loadingfilters: string
        manyselected: string
        nofiltersselected: string
        oneselected: string
        searchhits: string
        searchin: string
        selectall: string
        selectedvalues: string
        showmore: string
        errormessage: string
    }
}

const GraphBlock: FC<GenericBlockData> = (props) => {
    const graphBlockProps = typeCheckedProps<GraphBlockProps>(
        props,
        'GraphBlock'
    )
    return <PowerBIReport {...graphBlockProps} />
}

const WrappedGraphBlock = ContainerViewport(GraphBlock)
export { WrappedGraphBlock as GraphBlock }
